export const DYNAMIC_FIELD_PARAMETERS = {
  company: "company",
  connection: "connection",
  consumer: "consumer",
  component: "component",
  description: "description",
  fromCompany: "fromCompany",
  generator: "generator",
  meter: "meter",
  rootMeter: "rootMeter",
  site: "site",
  supplied: "supplied",
  supplier: "supplier",
  toCompany: "toCompany"
} as const;
